
import axios from "axios";
import store from '@/store';
import router from '@/router/index';
let requestNew = axios.create({
  baseURL: 'https://v2.cargosoon.online',
  baseURL: 'https://cc.cargosoon.online',
  timeout:25000,
});

requestNew.interceptors.request.use((config) => {
  //需要携带token带给服务器
  if(store.state.user.token){
    config.headers.token = store.state.user.token;
    // config.headers.token = 'MTcwMDYzNDEzNF8xMjIyX2FhODNkMTA2MTY2MDY3M2NiOWI1OGRlMTYwZjRkOWNlZmFkN2FiMDVfOTc5N19kYXZlLmhlQGNvLWxvZ2lzdGljcy5jb20='
    // config.headers.token = 'MTcwMDQ0MzU0Ml8xMjIyX2FhODNkMTA2MTY2MDY3M2NiOWI1OGRlMTYwZjRkOWNlZmFkN2FiMDVfNjA1M19kYXZlLmhlQGNvLWxvZ2lzdGljcy5jb20='
  }else if(window.localStorage.getItem("Touriststoken")){ //游客token
    config.headers.Touriststoken = window.localStorage.getItem("Touriststoken")
  }
  return config;
});

requestNew.interceptors.response.use(
  (res) => {
    // if(res.data.msg=='请先登录'){
    //   store.dispatch('userLogout')
    //   router.push('/login')
    // }
    if(res.data.msg=='token失效' || res.data.msg=='账号异常'){
      store.dispatch('userLogout')
      router.push('/login')
    }
    return res.data;
  },
  (err) => {
   
  }
);
export default requestNew;
